import { Injectable } from '@angular/core';

import { TaskMapper } from '../contracts/task-mapper.contract';
import { TaskDataMap, TaskResponse, TaskType } from '../models/task.interface';

function normalizePhone(phone: string | undefined): string {
  if (!phone) return '';
  return phone.startsWith('+') ? phone : `+${phone}`;
}

@Injectable()
export class CheckPlannedAppointmentTaskMapper implements TaskMapper<TaskType.CheckPlannedAppointment> {
  readonly type = TaskType.CheckPlannedAppointment;

  map(r: TaskResponse): TaskDataMap[TaskType.CheckPlannedAppointment] {
    return {
      memberId: r.data?.['memberId'] ?? '',
      memberName: r.data?.['memberName'] ?? '',
      memberPhoneNumber: normalizePhone(r.data?.['memberPhoneNumber']),
      partnerId: r.data?.['partnerId'] ?? '',
      partnerName: r.data?.['partnerName'] ?? '',
      partnerPhoneNumbers: r.data?.['partnerPhoneNumbers'] ?? <string[]>[],
      locationId: r.data?.['locationId'] ?? '',
      locationName: r.data?.['locationName'] ?? '',
      locationAddress: r.data?.['locationAddress'] ?? '',
      doctorName: r.data?.['doctorName'] ?? '',
      doctorId: r.data?.['doctorId'] ?? '',
      appointmentId: r.data?.['appointmentId'] ?? '',
      appointmentStartDate: r.data?.['appointmentStartDate'] ? new Date(r.data['appointmentStartDate']) : null,
      serviceName: r.data?.['serviceName'] ?? '',
      guaranteeId: r.data?.['guaranteeId'] ?? '',
      prescriptionId: r.data?.['prescriptionId'] ?? '',
      planningId: r.data?.['planningId'] ?? '',
      actionId: r.data?.['actionId'] ?? '',
    };
  }
}
